import { transportPage, transportPageImage } from "./article_transportpage_template";
import { cardsFront } from "../../templates/modules/cardlisting";
import { newslistFront } from "../../templates/modules/newslist";
import { createGuid } from "../../scripts/general_functions.js";
import { getImageByContentId, setResponsiveImages } from "../../scripts/images";

export const article_transportpage = (article) => {

    let contentHtml = document.getElementById("contentHtml");
    let maincontent = document.getElementById("maincontent");

    contentHtml.classList.remove('container');
    maincontent.classList.add('transportside');
    // add bg color to bradcrumb div
    // #maincontent .container .row
    let org_html = document.querySelector("#maincontent .container").outerHTML;
    let new_html = "<div class='row'>" + org_html + "</div>";
    document.querySelector("#maincontent .container").outerHTML = new_html;

    let category = article.categories[0].categoryId;
    const meta = article.metaObject || false;
    const metaData = $.parseJSON(decodeURIComponent(meta));
    let imgId = createGuid();
    let hasImage = metaData.imageContentId ? true : false;
    let mainImage = transportPageImage({ id: imgId });
    // `
    //     <div class="article__introimage__container col-md-4">
    //         <img src="" style="width:200px;height:200px;" alt="" class="article__introimage" id="${imgId}" >
    //     </div>`;

    getImageByContentId(metaData.imageContentId, (img) => {
        let cloudinaryUrl = "";
        if (img.url !== undefined && img.url.length > 0) {
            if ($(document).width() < 768) {
                //Mobile view
                cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_auto,w_200,h_200,c_fill,r_max/" + img.url;
            }
            else {
                //Desktop view
                cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_auto,w_200,h_200,c_fill,r_max/" + img.url;
            }
            $(`#${imgId}`).attr("src", cloudinaryUrl);
        }
    });
    let maxItems = 100, moduleTitle = "", moduleMoreText = "", moduleMoreLink = "";

    let content = ``;
    if (article.content.match(/\[modul:.+?\]/gmi)) {
        article.content.match(/\[modul:.+?\]/gmi).forEach((me) => {

            let modulename = me.replace("[modul:", "").replace("]", "");
            if (modulename.match("nyhetliste")) {
                content = newslistFront(maxItems, moduleTitle, "card__design__news1");
            } //else {
            //     content = cardsFront(category, maxItems, moduleTitle, moduleMoreText, moduleMoreLink, "card__design__3");
            // }
        });
    } else {
        content = cardsFront(category, maxItems, moduleTitle, moduleMoreText, moduleMoreLink, "card__design__3", true);
    }

    // let content = cardsFront(category, maxItems, moduleTitle, moduleMoreText, moduleMoreLink, moduleCardDesign);

    return transportPage({
        pageType: article.pageTypeId,
        title: article.title,
        parsedIntro: article.metaDynamic["Intro"],
        hasImage: hasImage,
        mainImage: mainImage,
        content: content,
    });

}
